import { useState } from "react";
import { api, apiError } from "./api";

// Aviah-branded admin sign-in.
const Login = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/admin/auth/login", { email, password });
      onSuccess(data);
    } catch (err) {
      setError(apiError(err, "Sign in failed."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#171717] px-5" data-testid="admin-login">
      <div className="w-full max-w-sm">
        <div className="text-center">
          <img src="/assets/logo-gold-film.webp" alt="Aviah Financial" className="mx-auto w-56" />
          <p className="mt-6 text-[0.6rem] font-medium uppercase tracking-[0.4em] text-[#C6A46A]">
            Private Control Center
          </p>
        </div>
        <form onSubmit={submit} className="mt-10 space-y-5 border border-[#F4F0E8]/10 bg-[#1E1E1E] p-8">
          <div>
            <label htmlFor="admin-email" className="mb-2 block text-[0.62rem] font-medium uppercase tracking-[0.18em] text-[#F4F0E8]/55">
              Email
            </label>
            <input
              id="admin-email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full rounded-[3px] border border-[#F4F0E8]/15 bg-[#171717] px-4 py-3 text-sm text-[#F4F0E8] transition-colors focus:border-[#C6A46A] focus:outline-none"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-2 block text-[0.62rem] font-medium uppercase tracking-[0.18em] text-[#F4F0E8]/55">
              Password
            </label>
            <input
              id="admin-password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full rounded-[3px] border border-[#F4F0E8]/15 bg-[#171717] px-4 py-3 text-sm text-[#F4F0E8] transition-colors focus:border-[#C6A46A] focus:outline-none"
            />
          </div>
          {error && (
            <p className="text-xs text-[#C6A46A]" data-testid="admin-login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full rounded-[3px] border border-[#C6A46A] bg-[#C6A46A] px-6 py-3.5 text-[0.68rem] font-medium uppercase tracking-[0.2em] text-[#171717] transition-colors duration-300 hover:bg-transparent hover:text-[#C6A46A] disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="mt-6 text-center text-[0.65rem] text-[#F4F0E8]/30">
          Authorized access only. All activity is logged.
        </p>
      </div>
    </div>
  );
};

export default Login;
